/**
 * Helper funkcie pre formátovanie peňažných hodnôt a daňových sadzieb
 */

/**
 * Formátuje centy na eurá s 2 desatinnými miestami
 * @param cents - hodnota v centoch
 * @returns formátovaný reťazec s € (napr. "12.50 €")
 */
export function formatMoney(cents?: number): string {
  if (cents === undefined || cents === null) return '0.00 €';
  return (cents / 100).toFixed(2) + ' €';
}

/**
 * Formátuje basis points na percentá s 2 desatinnými miestami
 * @param bp - hodnota v basis points (100 bp = 1%)
 * @returns formátovaný reťazec s % (napr. "21.00 %")
 */
export function formatTax(bp?: number): string {
  if (typeof bp !== 'number') return '';
  return (bp / 100).toFixed(2) + ' %';
}

/**
 * Formátuje číslo na percentá s 2 desatinnými miestami
 * @param value - hodnota (napr. 0.21 pre 21%)
 * @returns formátovaný reťazec s % (napr. "21.00 %")
 */
export function formatPercentage(value?: number): string {
  if (typeof value !== 'number') return '';
  return (value * 100).toFixed(2) + ' %';
}












